export default "__VITE_ASSET__Wxwoogz___"